import React from "react";
import HeaderDefaultToPage from "../../../../components/Common/headerDefaultToPage";

export default function GridHeader() {
  return (
    <HeaderDefaultToPage
      title="Editar Agendamento"
      goBack={false}
    />
  );
}